import * as _ from 'lodash';
import { Serializable } from '../deserialize.service';
import { RecipientType } from './../../enums/accounting/recipientType.enum';
import { InvoicePartner } from './invoicePartner.model';

export class InvoiceRecipient extends InvoicePartner implements Serializable<InvoiceRecipient> {
    type: RecipientType;
    deserialize(input) {
        if (_.isNil(input)) {
            return undefined;
        }
        this.type = input.type;
        super.deserialize(input);

        return this;
    }
}
